import { render, staticRenderFns } from "./KeapMarketingSmsTemplateManagerFooter.vue?vue&type=template&id=0f87b793&scoped=true"
import script from "./KeapMarketingSmsTemplateManagerFooter.vue?vue&type=script&lang=js"
export * from "./KeapMarketingSmsTemplateManagerFooter.vue?vue&type=script&lang=js"
import style0 from "./KeapMarketingSmsTemplateManagerFooter.vue?vue&type=style&index=0&id=0f87b793&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f87b793",
  null
  
)

export default component.exports